import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { UserComponent } from './user.component';
import { UserFormComponent } from './user-form/user-form.component';
import { PermissionService } from 'app/security/permission';
import { ROLE } from './roles.const';
import { UserResolve } from './user.resolve';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [PermissionService],
    data: {
      only: ROLE.GUEST,
      redirectTo: ''
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/user-routing.module.ts